<script setup>
import {getCurrentInstance, ref, watch, computed} from "vue"

import VerticalModal from "@/components/base/VerticalModal.vue"
import { useStore } from "vuex"
import BaseSelect from "@/components/base/select/BaseSelect.vue";

const store = useStore()

let anbar_id = ref('')
let loading_update = ref(false)


const props = defineProps({
  modelValue: { type: Boolean, default: false },
  load: { type: Object, default: null},
  warehouses: { type: Object, default: null},
  referred_code: { type: String, default: ''}
})

const emit = defineEmits(['update:visible', 'close', 'updated'])

const close = () => {
  emit('update:modelValue', false)
  emit('close', true)
}

const { proxy } = getCurrentInstance()

const update_order = () => {
  loading_update.value = true

  const data = {
    load_id: props.load.id,
    referred_code: props.referred_code,
    anbar_id: anbar_id.value,
  }

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }
  // eslint-disable-next-line no-undef
  axios.post('/orders/update_order_referred', data, config).then((response) => {
    if (response?.data?.load_detail_template) {
      emit('updated', {
        load_detail_template: response.data.load_detail_template,
      })

      proxy.$my_alert(response.data.message, 'success')
      close()
    }
    loading_update.value = false
  })
}

watch(
  () => props.referred_code,
  (val) => {
    if (val) {
      anbar_id.value= props.load.referreds.find(x => x.referred_code === val)?.pivot.anbar_id
    }
  },
  { immediate: true }
)

const options = computed(() => {
  return props.warehouses.map(warehouse => ({
    value: warehouse.Cod,
    label: warehouse.Nam
  }))
})


</script>

<template>
  <vertical-modal :visible="modelValue"
                  @close="close"
                  body-class="tw-py-4 tw-px-6"
                  header-icon="edit-note"
                  :header-title="'ویرایش انبار خروجی حواله <b>' + referred_code + '</b>'">
    <template #body>
      <base-select :options="options" v-model="anbar_id" title="انبار خروجی" :float-title="true" />

    </template>
    <template #footer>
      <btn-ayandeh
        @click="close"
        label="انصراف"
        color="light"
        class="ms-2"
        :disabled="loading_update"
      />
      <btn-ayandeh
        @click="update_order"
        label="ذخیره"
        :loading="loading_update"
      />
    </template>
  </vertical-modal>

</template>

<style scoped>

</style>
